import { PlusOutlined } from "@ant-design/icons";
import { Col, Form, Input, Modal, Row, Select, Space, Upload } from "antd";
import DebounceSelect from "components/common/DebounceSelect";
import { useState } from "react";
import { toast } from "react-toastify";
import commonApi from "utils/api";
import {
  getBase64,
  getPhotoThumbnailUrl,
  getPhotoUrl,
  getSlug,
} from "utils/common";
import { formItemLayoutHorizontal } from "utils/constants";

const { TextArea } = Input;

function ComboDetailModal(props) {
  const [form] = Form.useForm();
  const { open, isProcessing, onSubmit, onCancel, combo } = props;
  const [thumbUrl, setThumbUrl] = useState(
    getPhotoThumbnailUrl(combo?.thumb?.path || null)
  );
  const [coverUrl, setCoverUrl] = useState(
    getPhotoUrl(combo?.cover?.path || null, "w=200&h=102")
  );
  const [thumb, setThumb] = useState(null);
  const [cover, setCover] = useState(null);

  const initialValues = combo
    ? {
        ...combo,
        voucher: combo.voucher._id,
      }
    : {
        name: "",
        price: 0,
        days: 0,
        quantity: 0,
        priority: 99,
        active: true,
      };
  const onValuesChange = (changedValues) => {
    if (changedValues.name) {
      form.setFieldValue("slug", getSlug(changedValues.name));
    }
  };

  const onOK = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        const combo = { ...initialValues, ...values };
        if (combo.restaurants) {
          combo.restaurants = combo.restaurants.map((e) => e.value);
        }
        Object.entries({
          data: JSON.stringify(combo),
          thumb,
          cover,
        }).forEach(([key, value]) => {
          formData.append(key, value);
        });

        delete combo.time;

        onSubmit(combo, formData);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const beforeUploadThumb = async (file) => {
    const validType =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/webp";
    if (!validType) {
      toast.error("Chỉ chấp nhận file ảnh!");
    } else {
      const preview = await getBase64(file);
      setThumbUrl(preview);
      setThumb(file);
    }
    return false;
  };

  const beforeUploadCover = async (file) => {
    const validType =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/webp";
    if (!validType) {
      toast.error("Chỉ chấp nhận file ảnh!");
    } else {
      const preview = await getBase64(file);
      setCoverUrl(preview);
      setCover(file);
    }
    return false;
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Modal
      title="Gói tiết kiệm"
      okText="Lưu"
      cancelText="Huỷ"
      centered
      open={open}
      onOk={onOK}
      onCancel={onCancel}
      confirmLoading={isProcessing}
      width={800}
    >
      <Form
        {...formItemLayoutHorizontal}
        form={form}
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          name="name"
          label="Tên gói"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <Input placeholder="Tên gói" />
        </Form.Item>
        <Form.Item
          name="content"
          label="Nội dung"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <TextArea
            autoSize={{ minRows: 2, maxRows: 5 }}
            placeholder="Nội dung chi tiết của gói"
          />
        </Form.Item>
        <Form.Item
          name="voucher"
          label="ID voucher"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <Input placeholder="ID voucher mẫu" />
        </Form.Item>
        <Form.Item
          name="price"
          label="Giá tiền"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <Input type={"number"} min={0} />
        </Form.Item>
        <Form.Item
          name="days"
          label="Số ngày sử dụng"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <Input type={"number"} min={0} />
        </Form.Item>
        <Form.Item
          name="quantity"
          label="Số lượt sử dụng"
          rules={[
            {
              required: true,
              message: "Trường này là bắt buộc",
            },
          ]}
        >
          <Input type={"number"} min={0} />
        </Form.Item>
        <Form.Item name="priority" label="Thứ tự ưu tiên">
          <Input type={"number"} min={0} />
        </Form.Item>
        <Form.Item
          name="active"
          label="Trạng thái"
          rules={[{ required: true }]}
        >
          <Select placeholder="--Trạng thái--">
            <Select.Option value={true}>Active</Select.Option>
            <Select.Option value={false}>In-active</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Ảnh Thumb"
          tooltip="Ảnh hiển thị ngoài trang chủ (vuông)"
        >
          <Upload
            accept={"image/*"}
            name="thumb"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            beforeUpload={beforeUploadThumb}
          >
            {thumbUrl ? (
              <img src={thumbUrl} alt="image" style={{ width: "100%" }} />
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <Form.Item
          label="Ảnh Cover"
          tooltip="Ảnh hiển thị trang chi tiết (hình chữ nhật)"
        >
          <Space>
            <Upload
              accept={"image/*"}
              name="cover"
              listType="picture-card"
              className="avatar-uploader-cover"
              showUploadList={false}
              beforeUpload={beforeUploadCover}
            >
              {coverUrl ? (
                <img src={coverUrl} alt="image" style={{ width: "100%" }} />
              ) : (
                uploadButton
              )}
            </Upload>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default ComboDetailModal;
